import React from 'react'

const Para = () => {
    return (
        <>
            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Vel commodi sequi, id, velit expedita veritatis maiores possimus amet consectetur, adipisicing elit. Vel commodi sequi, id, velit expedita veritatis maiores possimus
              quae </p>
        </>
    )
}

export default Para;
